import React from 'react';

export default class GetData extends React.Component {
    
    constructor() {
        super();
    
        this.state = {
          componentData: ''
        };
      }

  componentDidMount() {
    var formatDate = new Date(this.props.appointment_date);
    //console.log("Format Date: " + formatDate);
    var ano = formatDate.getFullYear();
    var m = formatDate.getMonth();
    var d = formatDate.getDate();
    var h = formatDate.getHours();
    var min = formatDate.getMinutes();
    if(min < 10){
      this.setState({
          componentData: d + "/" + (m + 1) + "/" + ano + " - " + h + ":0" + min,
      })
      
    }else{
      this.setState({
          componentData: d + "/" + (m + 1) + "/" + ano + " - " + h + ":" + min,
      })        
    }

  }
      
    

  render() {
    return (
      <>
        <span>{this.state.componentData}</span>
      </>
    )
  }
}